import DayClosureService from '../../services/day-closure/DayClosureService'
import { StorageService } from '../../services/StorageService'
import i18n from '../../i18n/index'

export default {
  props: {
    onRowClick: {
      type: Function,
      default: () => { }
    }
  },
  data () {
    return {
      headers: [
        {
          text: i18n.t('headers.date'),
          sortable: false,
          value: 'dayClosureDate'
        },
        {
          text: i18n.t('headers.responsable'),
          sortable: false,
          value: 'user'
        },
        { text: i18n.t('headers.provider'),
          value: 'provider',
          sortable: false
        },
        {
          text: i18n.t('headers.status'),
          value: 'completed',
          sortable: false
        }
      ],
      itemsData: []
    }
  },
  created () {
    this.userData = StorageService.getUserData()
    this.getDayClosures()
  },
  methods: {
    async getDayClosures () {
      try {
        const res = await DayClosureService.getDayClosures(this.userData.id)
        if (res) {
          this.itemsData = res.data
        }
      } catch (error) { }
    }
  }
}
